import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import ReplyItem from './ReplyParts/ReplyPart-Item'
import ReplyGroup from './ReplyParts/ReplyPart-Group'

import timestamps from '~/services/timestamps'
import TextEdit from '~/services/textedit'

import { toggleReplyFlare } from '~/actions/statement'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.func.isRequired,
		expanded: PropTypes.bool.isRequired,
		toggleReplies: PropTypes.func.isRequired,
		statement: PropTypes.object.isRequired
	};

    toggleReplies = () => {
		this.props.toggleReplies()
	};

    toggleReplyFlare = (ID) => {
		this.props.dispatch( toggleReplyFlare(ID) )
	};

    render() {

		let firstReply = this.props.statement.replies[0],
			expandedReplies = this.props.statement.replies.slice(1, this.props.statement.replies.length),
			noOfRepliesLeft = +this.props.statement.reply_count - 1 - ('children' in firstReply ? firstReply.children.length : 0);

		return (
			<div className="mtop5">
				<ReplyGroup {...firstReply} dispatch={this.props.dispatch} statementID={this.props.statement.ID} toggleReplyFlare={this.toggleReplyFlare} />
				{ this.props.expanded && expandedReplies.length > 0 && expandedReplies.map( reply => { 
					return <ReplyGroup {...reply} dispatch={this.props.dispatch} statementID={this.props.statement.ID} toggleReplyFlare={this.toggleReplyFlare} key={'reply-'+reply.ID} /> 
				} ) }
				<div className="clearfix"></div>
				{ expandedReplies.length > 0 &&
					<div className="bg-pale-gray text-center small clickable ptop5 pbot5 text-light-success" onClick={this.toggleReplies}>
						{ !this.props.expanded ? noOfRepliesLeft + " More Comments" : <i className="icon-cross"></i> }
					</div>
				}
        	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ContentPart-Replies.jsx